import React, { Suspense, lazy, useMemo, useState } from "react";
import {
  Route,
  Routes,
  Navigate
} from "react-router-dom";

import Home from './view/Home';
import Footer from './component/Footer'
import { ThemeProvider } from "styled-components";
import { PROJECT_THEME } from "./theme";
import { AppGlobalStyle } from "./globalStyles";
import NavigationBar from "./component/NavigationBar";
import './App.css'
import SteppedPage from "./component/SteppedPage";
import ArticleView from "./view/Article";
import Terms from "./view/Terms";
import About from "./view/About";
import { ABOUT_ROUTE } from "./routes";
import { resolveSite } from "./site/resolveSite";

// Kept out of the main bundle so oneillsoft.com never pays for the sub-brand sites or the design labs.
const DiscreetEngineSite = lazy(() => import('./site/engine'));
const ModularHardwareSite = lazy(() => import('./site/hardware'));
const EducationSite = lazy(() => import('./site/education'));
const ContactLab = lazy(() => import('./component/ContactLab'));
const ServiceAnimationLab = lazy(() => import('./component/ServiceAnimationLab'));
const ServiceGridLab = lazy(() => import('./component/ServiceGridLab'));
const ServiceCardContentLab = lazy(() => import('./component/ServiceCardContentLab'));
const FAQLab = lazy(() => import('./component/FAQLab'));
const ArticleLab = lazy(() => import('./component/ArticleLab'));
const EdgeLab = lazy(() => import('./component/EdgeLab'));
const StatSparklineLab = lazy(() => import('./component/StatSparklineLab'));


function CoreApp() {
  const [isLightMode, setIsLightMode] = useState(false);

  const theme = useMemo(() => {
    if (!isLightMode) {
      return PROJECT_THEME;
    }

    return {
      ...PROJECT_THEME,
      colour: {
        ...PROJECT_THEME.colour,
        DARK_GREY: PROJECT_THEME.colour.OFF_WHITE,
        OFF_WHITE: PROJECT_THEME.colour.DARK_GREY,
      },
    };
  }, [isLightMode]);

  const handleToggleTheme = () => {
    setIsLightMode((prev) => !prev);
  };

  return (
    <ThemeProvider theme={theme}>
        <AppGlobalStyle />
        <NavigationBar isLightMode={isLightMode} onToggleTheme={handleToggleTheme} />
        <Suspense fallback={null}>
        <Routes>
          <Route path='/' element={
              <SteppedPage>
                <Home/>
              </SteppedPage>

          }/>
          <Route path='/articles/:slug' element={
              <SteppedPage>
                <ArticleView/>
              </SteppedPage>
          }/>
          <Route path='/terms' element={
              <SteppedPage>
                <Terms/>
              </SteppedPage>
          }/>
          <Route path={ABOUT_ROUTE} element={
              <SteppedPage>
                <About/>
              </SteppedPage>
          }/>
          <Route path='/faq-lab' element={<FAQLab/>} />
          <Route path='/article-lab' element={<ArticleLab/>} />
          <Route path='/edge-lab' element={<EdgeLab/>} />
          <Route path='/contact-lab' element={<ContactLab/>} />
          <Route path='/service-lab' element={<ServiceAnimationLab/>} />
          <Route path='/service-grid-lab' element={<ServiceGridLab/>} />
          <Route path='/service-content-lab' element={<ServiceCardContentLab/>} />
          <Route path='/stat-sparkline-lab' element={<StatSparklineLab/>} />
          <Route path='*' element={<Navigate to="/"/>} />
        </Routes>
        </Suspense>
        <Footer/>
    </ThemeProvider>
    
  );
}

function App() {
  const site = useMemo(resolveSite, []);

  if (site === 'engine') {
    return (
      <Suspense fallback={null}>
        <DiscreetEngineSite/>
      </Suspense>
    );
  }

  if (site === 'hardware') {
    return (
      <Suspense fallback={null}>
        <ModularHardwareSite/>
      </Suspense>
    );
  }

  if (site === 'education') {
    return (
      <Suspense fallback={null}>
        <EducationSite/>
      </Suspense>
    );
  }

  return <CoreApp/>;
}

export default App;